<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command">
      <span class="table-command-item-key">桥梁:</span>
      <el-select v-model="bridgeId" placeholder="请选择桥梁">
        <el-option v-for="item in bridgeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <span class="table-command-item-key">设备组:</span>
      <el-select class="table-command-select" v-model="filterData.stationName" placeholder="请选择设备组" clearable>
        <el-option v-for="item in stationNameList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <span class="table-command-item-key">字段名称:</span>
      <el-input class="table-command-input" v-model="filterData.deviceName" placeholder="请输入字段名称" clearable></el-input>
      <span class="table-command-item-key">连接状态:</span>
      <el-select class="table-command-select" v-model="filterData.isCommValid" placeholder="选择连接状态" clearable>
        <el-option :key="true" :label="'有效'" :value="true"></el-option>
        <el-option :key="false" :label="'中断'" :value="false"></el-option>
      </el-select>

      <!--右侧-->
      <el-tag class="percentage-tag dh-right" effect="dark" :type="reportTagType">{{ report.CurrentValidCommPercentage }}</el-tag>
      <span class="table-command-item-key dh-right">连接比例: </span>
      <span class="table-command-item-key dh-right">连接数量: {{ report.currentValidCommCount_expected }}</span>
      <span class="table-command-item-key dh-right">字段数量: {{ report.currentValidCommCount }}</span>
    </div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" prop="index" width="80"></el-table-column>
      <el-table-column align="center" label="字段名称" prop="deviceName"></el-table-column>
      <el-table-column align="center" label="所属设备组" prop="stationName"></el-table-column>
      <el-table-column align="center" label="所属桥梁" prop="bridgeName"></el-table-column>
      <el-table-column align="center" label="最近数据时间" prop="lastValidCommDate"></el-table-column>
      <el-table-column align="center" label="连接状态" width="100">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.commTagType">{{ scope.row.IsCommValidString }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "RemoteHistory",
  data() {
    return {
      timer: null,
      tableData: [],
      fullData_beforeFilter: [],
      fullData_afterFilter: [],
      stationNameList: [],
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 0,
      currentPage: 1,
      pageSize: 12,
      bridgeId: "",
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      firstIndex: 0,
      lastIndex: 0,
      filterData: {
        stationName: "",
        deviceName: "",
        isCommValid: undefined,
      },
      report: {
        currentValidCommCount: 0,
        currentValidCommCount_expected: 0,
        CurrentValidCommPercentage: 0,
      },
      reportTagType: "",
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
  },
  mounted() {
    this.loading = true;
    if (this.$route.query.bridgeId) {
      let validBridgeId = false;
      for (let bridge of this.bridgeList) {
        if (bridge.id === this.$route.query.bridgeId) {
          validBridgeId = true;
          break;
        }
      }

      if (validBridgeId) {
        this.bridgeId = this.$route.query.bridgeId;
      }
    }

    if (!this.bridgeId || this.bridgeId === "") {
      this.bridgeId = this.bridgeList[0].id;
    }

    this.getDataList();

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };

    this.timer = setInterval(() => {
      this.getDataList();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    bridgeId() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.bridgeId = this.bridgeId;
      this.$router.replace({ query: query });

      this.refreshData();
    },
    filterData: {
      handler: function () {
        this.loading = true;
        this.getFilteredData();
      },
      deep: true,
    },
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.filterData.stationName = "";
      this.filterData.deviceName = "";
      this.filterData.isCommValid = undefined;

      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;
      this.getPageData();
    },
    getDataList() {
      if (!this.bridgeId || this.bridgeId === "") {
        this.fullData_beforeFilter = [];
        return;
      }

      let reportQuery = this.$http.get("/socketCommStatus/GetSocketCommStatusReport?bridgeId=" + this.bridgeId);
      let detailQuery = this.$http.get("/socketCommStatus/GetSocketCommDetailReport?bridgeId=" + this.bridgeId);

      this.$http.all([reportQuery, detailQuery]).then(
        this.$http.spread((reportRes, detailRes) => {
          let data = reportRes.data[0];
          this.report = data;
          let commStatusList = detailRes.data;

          if (data.CurrentValidCommPercentage > 90) {
            this.reportTagType = "success";
          } else if (data.CurrentValidCommPercentage > 50) {
            this.reportTagType = "warning";
          } else {
            this.reportTagType = "danger";
          }

          let index = 0;
          let stationNameList = [];
          for (let dataItem of commStatusList) {
            index += 1;
            dataItem.index = index;

            if (dataItem.IsCommValid) {
              dataItem.commTagType = "success";
              dataItem.IsCommValidString = "连接有效";
            } else {
              dataItem.commTagType = "danger";
              dataItem.IsCommValidString = "连接中断";
            }

            if (dataItem.lastValidCommDate) {
              dataItem.lastValidCommDate = dateTimeToString(newtonsoftJsonToDate(dataItem.lastValidCommDate), "yy年MM月dd日 HH:mm");
            }

            if (stationNameList.indexOf(dataItem.stationName) < 0) {
              stationNameList.push(dataItem.stationName);
            }
          }

          this.stationNameList = stationNameList;
          this.fullData_beforeFilter = commStatusList;
          this.getFilteredData();
        })
      );
    },
    getFilteredData() {
      let result = [];
      for (let dataItem of this.fullData_beforeFilter) {
        if (this.filterData.stationName && this.filterData.stationName != "") {
          if (dataItem.stationName != this.filterData.stationName) {
            continue;
          }
        }
        if (this.filterData.deviceName && this.filterData.deviceName != "") {
          if (dataItem.deviceName.indexOf(this.filterData.deviceName) < 0) {
            continue;
          }
        }
        if (this.filterData.isCommValid !== undefined && this.filterData.isCommValid !== "") {
          if (dataItem.IsCommValid != this.filterData.isCommValid) {
            continue;
          }
        }

        result.push(dataItem);
      }

      this.fullData_afterFilter = result;
      this.totalCount = result.length;
      this.currentPage = 1;
      this.getPageData();
    },
    getPageData() {
      let startIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = this.currentPage * this.pageSize - 1;

      let dataList = [];
      for (let i = startIndex; i <= endIndex; i++) {
        if (i >= this.fullData_afterFilter.length) {
          break;
        }

        dataList.push(this.fullData_afterFilter[i]);
      }

      this.tableData = dataList;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    translateBridgeName(bridgeId) {
      for (let bridge of this.bridgeList) {
        if (bridge.id === bridgeId) {
          return bridge.name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    // display: flex;
    // justify-content: flex-end;
    margin-bottom: 20px;
  }
  .table-command-item-key {
    margin-right: 10px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .table-command-input {
    width: 150px;
  }
  .table-command-select {
    width: 150px;
  }
  .dh-right {
    float: right;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-bottom: 10px;
  margin-left: 10px;
}
.percentage-tag {
  min-width: 75px;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
